import { css } from '@emotion/react';

export const loaderContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
